<template>
    <div class="notices_components">
      <h1>お知らせ</h1>
        <div v-for="notice in notices" :key="notice.id">
          <p>{{ modifyDatetime(notice.createdAt) }}</p>
          <p class="notice_title"><router-link :to="{name:'notice', params:{ id: notice.id}}">{{notice.title}}</router-link></p>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import moment from 'moment'
export default {
  components: {},
  data() {
    return {
      notices:'',
    };
  },
  mounted() {
    this.fetchNotice();
    const title = "お知らせ一覧｜メモや日記ついでに英語学習"
    const description = "メモや日記ついでに英語学習のお知らせ一覧画面です"
    document.title = title
    document.querySelector("meta[property='og:title']").setAttribute('content', title)
    document.querySelector("meta[name='description']").setAttribute('content', description)
    document.querySelector("meta[property='og:description']").setAttribute('content', description)
  },
  methods: {
    fetchNotice() {
      axios.get("https://translate.microcms.io/api/v1/notice", {
        headers: { "X-API-KEY": process.env.VUE_APP_MICRO_CMS }
      }).then(res => {
        this.notices = res.data.contents;
      }).catch(err => {
        console.log(err);
      });
    },
    modifyDatetime(date) {
      return moment(date).locale('ja').format('LLL')
    },
  },
};
</script>

<style scoped>
.notices_components{
  max-width: 800px;
  margin: auto;
  padding:20px;
}
h1{
  font-weight: bold;
  font-size: 1.2em;
  text-align: center;
  padding-bottom: 10px;
}

</style>